import request from "arcdynamic-request";
import { backendServicesUrl } from "../consts/env";

export function executeQuery({queryName, params = false, options = false, expireTime = false}) {
    const req = options ?
        {
            service: 'arcimedes',
            action: 'open.dataquery.execute',
            params: [queryName],
            options: options
        }
        :
        {
            service: 'arcimedes',
            action: 'open.dataquery.execute',
            params: [queryName, {param: params}]
        };
    // Append a random parameter to force arcdynamic-request to treat this as a unique URL
    // and prevent it from batching this request with other concurrent requests.
    const url = `${backendServicesUrl}?_unbatch=${Date.now()}_${Math.floor(Math.random() * 1000000)}`;

    if (expireTime) {
        return request(url, req, {expires: expireTime});
    }
    return request(url, req);
}